<template>
<div class="top-nav">
  <div class="wrapper">
    <nav>
      <router-link v-for="page in pages" :key="page.path" :to="page.path">{{ page.name }}</router-link>
    </nav>
  </div>
</div>
</template>

<script>
export default {
  name: 'top-nav',
  props: [ 'pages' ]
}
</script>

<style scoped>
.top-nav {
  background-color: #4DEBBC;
}

nav {
  padding: 6px 0;
  text-align: center;
}

nav a {
  color: #203D3E;
  font-size: 1.5em;
  text-decoration: none;
  margin: 10px;
}

nav a:hover {
  color: #316F71;
}

nav a:active {
  color: #759596;
}
</style>



// WEBPACK FOOTER //
// src/components/top-nav.vue